export function formatAddress(address = '', numberOfCharacters = 4): string {
  const first = address.slice(2, 2 + numberOfCharacters);
  const last = address.slice(-numberOfCharacters);
  return `0x${first}...${last}`;
}
